/* eslint-disable no-case-declarations */
import React, { Component } from "react";
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import { SliderRail, Handle, Track, Tick } from "./components";
import { getDate } from "../../../utils/helper";
import moment from "moment/moment";
import { standardDateFormat } from "../../../constants/appConstants";

const sliderStyle = {
  position: "relative",
  width: "100%"
};

class CustomSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      min: getDate(`1/10/${props.selectedYear}`),
      max: getDate(`12/5/${props.selectedYear}`),
      tickValues: [getDate(props.selectedDate), getDate(props.selectedDate)],
      dateTicks: [],
      stepValue: 1000 * 60 * 60 * 24 * 30,
      isSliderValueSet: false
    };
  }

  componentDidMount() {
    const {isViewReport,sliderView} =this.props
    if (isViewReport === true) {
      this.setSliderValueOnPropsForReporting(sliderView, this.props);
    } else {
      this.setSliderValueOnProps(sliderView, this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {endDate,selectedYear,sliderView, minSliderVal} =this.props;
    if (
      endDate !== nextProps.endDate ||
      selectedYear !== nextProps.selectedYear ||
      sliderView !== nextProps.sliderView ||
      minSliderVal !== nextProps.minSliderVal
    ) {
      this.setSliderValueOnProps(nextProps.sliderView, nextProps);
    }
  }

  /**
   * format the slider trick
   * @param {*} ms -> selected date
   * @returns
   */
  formatTick = ms => {
    const {sliderView}=this.props;
    return moment(getDate(ms)).format(
      sliderView === "year" ? "YYYY" : "MMM YY"
    );
  };

  /**
   * update year when click on next button
   * @param {*} date
   * @param {*} gapVal
   * @returns
   */
  getPrevNextDate = (date, gapVal) => {
    const curMonth = date.getMonth() + gapVal;
    date.setMonth(curMonth);
    return date.getTime();
  };

  /**
   * set configuration of slider date
   * @param {*} sliderType
   * @param {*} props
   */
  setSliderValueOnProps = (sliderType, props) => {
    const {
      selectedDate,
      selectedYear,
      minSliderVal,
      maxSliderVal,
      // eslint-disable-next-line no-unused-vars
      singleTickSelection = false,
      defaultYearSelectionGap: defaultYearSelectionGap = 0,
      endDate
    } = props;
    let sliderObj = {};
    let endOfMonth = moment(endDate)
      .startOf("month")
      .format(standardDateFormat);
    const endOfMonthly = moment(selectedDate)
      .endOf("month")
      .format(standardDateFormat);
    const endDateOfMonth = moment()
      .startOf("month")
      .format(standardDateFormat);
    const currentYear = new Date().getFullYear();
    switch (sliderType) {
      case "year": {
        const yearValue = selectedYear;
        sliderObj = {
          min: getDate(`1/10/${yearValue - 2}`),
          max: getDate(`1/10/${yearValue}`),
          tickValues: [
            getDate(`1/10/${yearValue - defaultYearSelectionGap}`),
            getDate(`1/10/${yearValue}`)
          ],
          dateTicks: [
            getDate(`1/10/${yearValue - 2}`).getTime(),
            getDate(`1/10/${yearValue - 1}`).getTime(),
            getDate(`1/10/${yearValue}`).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 365,
          isSliderValueSet: true,
          left: false
        };
        break;
      }

      case "mtdRadio":
        let monthInc = 1;
        // set min and max value according to selected year
        const endOfMonthYear = moment(endOfMonth).year();
        const initialDefaultDate = moment([selectedYear])
          .endOf("year")
          .format(standardDateFormat);
        const startDefaultDate = moment([selectedYear])
          .startOf("year")
          .format(standardDateFormat);
        const formattedStartDate = new Date(startDefaultDate);
        const formattedEndDate = new Date(initialDefaultDate);
        const newMinSliderVal =
          minSliderVal.getFullYear() === selectedYear
            ? getDate(minSliderVal)
            : getDate(formattedStartDate);
        const newMaxSliderVal =
          maxSliderVal.getFullYear() === selectedYear
            ? getDate(maxSliderVal)
            : getDate(formattedEndDate);
        endOfMonth =
          maxSliderVal.getFullYear() === new Date().getFullYear() &&
          moment()
            .startOf("month")
            .format(standardDateFormat) <=
            moment(endOfMonth)
              .startOf("month")
              .format(standardDateFormat)
            ? moment()
                .startOf("month")
                .format(standardDateFormat)
            : endOfMonthYear === selectedYear
            ? endOfMonth
            : initialDefaultDate;
        sliderObj = {
          min: getDate(newMinSliderVal),
          max: getDate(newMaxSliderVal),
          tickValues: [
            getDate(
              moment(endOfMonth)
                .add(14, "days")
                .format(standardDateFormat)
            )
          ],
          dateTicks: [
            getDate(newMinSliderVal).getTime(),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            getDate(newMaxSliderVal).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 31,
          isSliderValueSet: true,
          left: true
        };
        break;
      case "qtdRadio":
        const monthIncQtr = 1;
        // set min and max value according to selected year
        const initialQtrDefaultDate = moment([selectedYear])
          .endOf("year")
          .format(standardDateFormat);
        const startQtrDate = moment([selectedYear])
          .startOf("year")
          .format(standardDateFormat);
        const startDateQtr = new Date(startQtrDate);
        const endDateQtr = new Date(initialQtrDefaultDate);
        const newMinSliderValQtr =
          minSliderVal.getFullYear() === selectedYear
            ? getDate(minSliderVal)
            : getDate(startDateQtr);
        const newMaxSliderValQtr =
          maxSliderVal.getFullYear() === selectedYear
            ? getDate(maxSliderVal)
            : getDate(endDateQtr);

        sliderObj = {
          min: getDate(newMinSliderValQtr),
          max: getDate(newMaxSliderValQtr),
          tickValues: [
            getDate(
              moment(endOfMonth)
                .add(1, "days")
                .format(standardDateFormat)
            )
          ],
          dateTicks: [
            getDate(newMinSliderValQtr).getTime(),
            this.getPrevNextDate(getDate(newMinSliderValQtr), monthIncQtr + 3),
            this.getPrevNextDate(getDate(newMinSliderVal), monthIncQtr + 6),
            this.getPrevNextDate(getDate(newMinSliderVal), monthIncQtr + 9)
          ],
          stepValue: 1000 * 60 * 60 * 24 * (365 / 4),
          isSliderValueSet: true,
          left: true
        };
        break;

      case "ytdRadio":
        sliderObj = {
          min: getDate(`1/10/${selectedYear}`),
          max: getDate(`12/16/${selectedYear}`),
          tickValues: [
            getDate(
              moment(endOfMonth)
                .add(14, "days")
                .format(standardDateFormat)
            )
          ],
          dateTicks: [
            getDate(`1/10/${selectedYear}`).getTime(),
            getDate(`2/9/${selectedYear}`).getTime(),
            getDate(`3/10/${selectedYear}`).getTime(),
            getDate(`4/11/${selectedYear}`).getTime(),
            getDate(`5/12/${selectedYear}`).getTime(),
            getDate(`6/12/${selectedYear}`).getTime(),
            getDate(`7/13/${selectedYear}`).getTime(),
            getDate(`8/14/${selectedYear}`).getTime(),
            getDate(`9/14/${selectedYear}`).getTime(),
            getDate(`10/15/${selectedYear}`).getTime(),
            getDate(`11/15/${selectedYear}`).getTime(),
            getDate(`12/16/${selectedYear}`).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 31,
          isSliderValueSet: true,
          left: false
        };
        break;
      default:
        sliderObj = {
          min: getDate(`1/10/${selectedYear}`),
          max: getDate(`12/16/${selectedYear}`),
          tickValues: [
            selectedYear === currentYear
              ? getDate(endDateOfMonth)
              : getDate(endOfMonthly)
          ],
          dateTicks: [
            getDate(`1/10/${selectedYear}`).getTime(),
            getDate(`2/9/${selectedYear}`).getTime(),
            getDate(`3/10/${selectedYear}`).getTime(),
            getDate(`4/11/${selectedYear}`).getTime(),
            getDate(`5/12/${selectedYear}`).getTime(),
            getDate(`6/12/${selectedYear}`).getTime(),
            getDate(`7/13/${selectedYear}`).getTime(),
            getDate(`8/14/${selectedYear}`).getTime(),
            getDate(`9/14/${selectedYear}`).getTime(),
            getDate(`10/15/${selectedYear}`).getTime(),
            getDate(`11/15/${selectedYear}`).getTime(),
            getDate(`12/16/${selectedYear}`).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 31,
          isSliderValueSet: true,
          left: false
        };
    }
    this.setState({ ...sliderObj });
  };

  /**
   * set configuration of slider date for reporting
   * @param {*} sliderType
   * @param {*} props
   */
  setSliderValueOnPropsForReporting = (sliderType, props) => {
    const { minSliderVal, maxSliderVal, startDate, endDate } = props;
    const selectedYear = new Date(startDate).getFullYear();
    const endDateYear = new Date(endDate).getFullYear();
    const getSelectedYear =
      startDate !== "NONE"
        ? new Date(startDate).getFullYear()
        : new Date().getFullYear();
    let sliderObj = {};
    const endOfMonth = moment(endDate)
      .startOf("month")
      .format(standardDateFormat);
    const endDateForMonthly = moment(endDate).format(standardDateFormat);
    const endDateOfMonth = moment()
      .startOf("month")
      .format(standardDateFormat);
    const currentYear = new Date().getFullYear();
    switch (sliderType) {
      case "year":
        const yearValue = endDateYear;
        sliderObj = {
          min: getDate(`1/10/${yearValue - 2}`),
          max: getDate(`1/10/${yearValue}`),
          tickValues: [
            getDate(`1/10/${getSelectedYear}`),
            getDate(`1/10/${yearValue}`)
          ],
          dateTicks: [
            getDate(`1/10/${yearValue - 2}`).getTime(),
            getDate(`1/10/${yearValue - 1}`).getTime(),
            getDate(`1/10/${yearValue}`).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 365,
          isSliderValueSet: true,
          left: false
        };
        break;

      case "mtdRadio":
        let monthInc = 1;
        // set min and max value according to selected year
        const initialDefaultDate = moment([selectedYear])
          .endOf("year")
          .format(standardDateFormat);
        const startDefaultDate = moment([selectedYear])
          .startOf("year")
          .format(standardDateFormat);
        const startDate = new Date(startDefaultDate);
        const endDate = new Date(initialDefaultDate);
        const newMinSliderVal =
          minSliderVal.getFullYear() === selectedYear
            ? getDate(minSliderVal)
            : getDate(startDate);
        const newMaxSliderVal =
          maxSliderVal.getFullYear() === selectedYear
            ? getDate(maxSliderVal)
            : getDate(endDate);

        sliderObj = {
          min: getDate(newMinSliderVal),
          max: getDate(newMaxSliderVal),
          tickValues: [
            getDate(
              moment(endOfMonth)
                .add(14, "days")
                .format(standardDateFormat)
            )
          ],
          dateTicks: [
            getDate(newMinSliderVal).getTime(),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            this.getPrevNextDate(getDate(newMinSliderVal), monthInc++),
            getDate(newMaxSliderVal).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 30.4,
          isSliderValueSet: true,
          left: true
        };
        break;
      case "qtdRadio":
        const monthIncQtr = 1;
        // set min and max value according to selected year
        const initialQtrDefaultDate = moment([selectedYear])
          .endOf("year")
          .format(standardDateFormat);
        const startQtrDate = moment([selectedYear])
          .startOf("year")
          .format(standardDateFormat);
        const startDateQtr = new Date(startQtrDate);
        const endDateQtr = new Date(initialQtrDefaultDate);
        const newMinSliderValQtr =
          minSliderVal.getFullYear() === selectedYear
            ? getDate(minSliderVal)
            : getDate(startDateQtr);
        const newMaxSliderValQtr =
          maxSliderVal.getFullYear() === selectedYear
            ? getDate(maxSliderVal)
            : getDate(endDateQtr);

        sliderObj = {
          min: getDate(newMinSliderValQtr),
          max: getDate(newMaxSliderValQtr),
          tickValues: [
            getDate(
              moment(endOfMonth)
                .add(14, "days")
                .format(standardDateFormat)
            )
          ],
          dateTicks: [
            getDate(newMinSliderValQtr).getTime(),
            this.getPrevNextDate(getDate(newMinSliderValQtr), monthIncQtr + 3),
            this.getPrevNextDate(getDate(newMinSliderVal), monthIncQtr + 6),
            this.getPrevNextDate(getDate(newMinSliderVal), monthIncQtr + 9)
          ],
          stepValue: 1000 * 60 * 60 * 24 * (365 / 4),
          isSliderValueSet: true,
          left: true
        };
        break;
      case "ytdRadio":
        sliderObj = {
          min: getDate(`1/10/${selectedYear}`),
          max: getDate(`12/16/${selectedYear}`),
          tickValues: [
            getDate(
              moment(endOfMonth)
                .add(14, "days")
                .format(standardDateFormat)
            )
          ],
          dateTicks: [
            getDate(`1/10/${selectedYear}`).getTime(),
            getDate(`2/9/${selectedYear}`).getTime(),
            getDate(`3/10/${selectedYear}`).getTime(),
            getDate(`4/11/${selectedYear}`).getTime(),
            getDate(`5/12/${selectedYear}`).getTime(),
            getDate(`6/12/${selectedYear}`).getTime(),
            getDate(`7/13/${selectedYear}`).getTime(),
            getDate(`8/14/${selectedYear}`).getTime(),
            getDate(`9/14/${selectedYear}`).getTime(),
            getDate(`10/15/${selectedYear}`).getTime(),
            getDate(`11/15/${selectedYear}`).getTime(),
            getDate(`12/16/${selectedYear}`).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 31,
          isSliderValueSet: true,
          left: false
        };
        break;

      default:
        sliderObj = {
          min: getDate(`1/10/${selectedYear}`),
          max: getDate(`12/16/${selectedYear}`),
          tickValues: [
            selectedYear === currentYear
              ? getDate(endDateOfMonth)
              : getDate(endDateForMonthly)
          ],
          dateTicks: [
            getDate(`1/10/${selectedYear}`).getTime(),
            getDate(`2/9/${selectedYear}`).getTime(),
            getDate(`3/10/${selectedYear}`).getTime(),
            getDate(`4/11/${selectedYear}`).getTime(),
            getDate(`5/12/${selectedYear}`).getTime(),
            getDate(`6/12/${selectedYear}`).getTime(),
            getDate(`7/13/${selectedYear}`).getTime(),
            getDate(`8/14/${selectedYear}`).getTime(),
            getDate(`9/14/${selectedYear}`).getTime(),
            getDate(`10/15/${selectedYear}`).getTime(),
            getDate(`11/15/${selectedYear}`).getTime(),
            getDate(`12/16/${selectedYear}`).getTime()
          ],
          stepValue: 1000 * 60 * 60 * 24 * 31,
          isSliderValueSet: true,
          left: false
        };
    }
    this.setState({ ...sliderObj });
  };

  /**
   * update value of start and end date of slider
   * @param {*} tickValues
   */
  onChange = tickValues => {
    const { sliderView, selectedYear, onChangeMonthRange } = this.props;
    const { isSliderValueSet } = this.state;
    if (isSliderValueSet) {
      this.setState(
        {
          tickValues
        },
        () => {
          let startDate = tickValues[0];
          let endDate = tickValues[0];
          switch (sliderView) {
            case "year":
              const lastMonthDate = new Date(
                `12/2/${new Date(tickValues[1]).getFullYear()}`
              ).getTime();
              endDate = lastMonthDate;
              break;
            case "mtdRadio":
              startDate = getDate(`01/01/${selectedYear}`);
              endDate = tickValues[0];
              break;
            case "qtdRadio":
              startDate = getDate(`01/01/${selectedYear}`);
              endDate = tickValues[0];
              break;
            case "ytdRadio":
              endDate = tickValues[0];
              break;
            case "ttmRadio":
              startDate = this.getPrevNextDate(getDate(tickValues[0]), -11); //Last 12 months data
              break;
          }
          // set start date is start of month and end date is end of month
          startDate = moment(startDate)
            .startOf("month")
            .format(standardDateFormat);
          endDate = moment(endDate)
            .endOf("month")
            .format(standardDateFormat);
          onChangeMonthRange(startDate, endDate);
        }
      );
    }
  };

  render() {
    const { min, max, tickValues, dateTicks, stepValue, left } = this.state;

    return (
      <>
        <div style={sliderStyle}>
          <Slider
            mode={1}
            step={stepValue}
            domain={[+min, +max]}
            rootStyle={sliderStyle}
            onChange={this.onChange}
            values={tickValues}
            key={"slider"}
          >
            <Rail>
              {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
            </Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div>
                  {handles.map(handle => (
                    <Handle
                      key={handle.id}
                      handle={handle}
                      domain={[+min, +max]}
                      getHandleProps={getHandleProps}
                    />
                  ))}
                </div>
              )}
            </Handles>
            <Tracks right={false} left={left || false}>
              {({ tracks, getTrackProps }) => (
                <div>
                  {tracks.map(({ id, source, target }) => (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      getTrackProps={getTrackProps}
                    />
                  ))}
                </div>
              )}
            </Tracks>
            <Ticks values={dateTicks}>
              {({ ticks }) => (
                <div className={"ticksGroup"}>
                  {ticks.map(tick => (
                    <Tick
                      key={tick.id}
                      tick={tick}
                      count={ticks.length}
                      format={this.formatTick}
                    />
                  ))}
                </div>
              )}
            </Ticks>
          </Slider>
        </div>
      </>
    );
  }
}

export default CustomSlider;
